import { render, staticRenderFns } from "./Pinned.vue?vue&type=template&id=6c3afcce&scoped=true&"
import script from "./Pinned.vue?vue&type=script&lang=js&"
export * from "./Pinned.vue?vue&type=script&lang=js&"
import style0 from "./Pinned.vue?vue&type=style&index=0&id=6c3afcce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3afcce",
  null
  
)

export default component.exports